// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Inter-VariableFont_opsz,wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --border-radius-lg: 10px;
  --border-radius-md: 5px;
  --border-radius-sm: 4px;
}

:root {
  /* ─── Primarios: campo / agro ─────────────────────── */
  --color-primary: #1B4332; /* Verde bosque profundo */
  --color-primary-mid: #2D6A4F; /* Verde medio */
  --color-primary-light: #52B788; /* Verde claro */
  --color-primary-surface: #D8F3DC; /* Verde muy suave */
  /* ─── Acento: tierra / cosecha ────────────────────── */
  --color-accent: #E76F00; /* Naranja tierra */
  --color-accent-light: #FFF0D6; /* Fondo suave acento */
  --color-amber: #F4A261; /* Ámbar cálido */
  /* ─── Legado (compatibilidad shared) ─────────────── */
  --color-blue-primary: #1B4332;
  --color-blue-secondary: #2D6A4F;
  --color-blue-light: #D8F3DC;
  --color-blue-hover: #163527;
  --color-dorado-primary: #F4A261;
  --color-blue: #1B4332;
  --color-lightblue: #52B788;
  /* ─── Estado ──────────────────────────────────────── */
  --color-green: #40916C;
  --color-green-light: #D8F3DC;
  --color-red: #D62828;
  --color-red-light: #FFE5E5;
  --color-yellow: #F4A261;
  --color-orange: #E76F00;
  --color-cyan: #2D6A4F;
  /* ─── Superficies ─────────────────────────────────── */
  --bg-main: #F2F4F0; /* Gris cálido, como papel */
  --bg-white: #FFFFFF;
  --bg-gray: #EAECE7;
  --bg-gray-hover: #DDE0D9;
  /* ─── Escala de grises ────────────────────────────── */
  --color-gray-100: #FFFFFF;
  --color-gray-200: #F5F6F4;
  --color-gray-210: #F2F4F0;
  --color-gray-300: #E2E6DF;
  --color-gray-400: #C8CCC5;
  --color-gray-500: #8E9489;
  --color-gray-600: #5E6459;
  --color-gray-800: #2C2F2A;
  --color-gray-900: #1A1C19;
  --color-gray-font: #5E6459;
  /* ─── Header / NavBar oscuro ──────────────────────── */
  --color-nav-bg: #1B4332;
  --color-nav-text: rgba(255,255,255,0.75);
  --color-nav-text-active: #FFFFFF;
  --color-nav-active: rgba(255,255,255,0.15);
  --color-nav-icon: rgba(255,255,255,0.65);
  /* Altura del navbar inferior (responsiva) + safe-area del home indicator.
     Usada por el navbar, el clearance global (.container) y el panel del mapa. */
  --nav-height: calc(10vh + env(safe-area-inset-bottom, 0));
  /* ─── Sombras ─────────────────────────────────────── */
  --shadow-sm: 0 1px 3px rgba(0,0,0,0.08);
  --shadow-md: 0 4px 12px rgba(0,0,0,0.1);
  --shadow-lg: 0 8px 24px rgba(0,0,0,0.14);
  /* ─── Bordes ──────────────────────────────────────── */
  --border-color: #D5D9D2;
  /* ─── Misc ────────────────────────────────────────── */
  --color-trasparent: rgba(0,0,0,0.02);
  --color-celeste-card: #D8F3DC;
  --color-green-light-whatsapp: #128C7E;
  --color-green-dark-whatsapp: #075E54;
}

/* ─── Utility classes ─────────────────────────────────── */
.color-gray-900 {
  color: var(--color-gray-900);
}

.color-gray-500 {
  color: var(--color-gray-500);
}

.text-white {
  color: #fff;
}

.bg-blue-primary {
  background: var(--color-primary);
}

.bg-blue-secondary {
  background: var(--color-primary-mid);
}

:root {
  --z-index-base: 1000;
  --z-index-overlay: calc(var(--z-index-base) + 100);
  --z-index-modal: calc(var(--z-index-overlay) + 100);
  --z-index-overlay-2: calc(var(--z-index-modal) + 100);
  --z-index-modal-2: calc(var(--z-index-overlay-2) + 100);
  --z-index-overlay-3: calc(var(--z-index-modal-2) + 100);
  --z-index-modal-3: calc(var(--z-index-overlay-3) + 100);
  --z-index-overlay-confirm: calc(var(--z-index-modal-3) + 100);
  --z-index-modal-confirm: calc(var(--z-index-overlay-confirm) + 100);
  --z-index-alert: calc(var(--z-index-modal-confirm) + 100);
}

@font-face {
  font-family: "Inter";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: 100 900;
  font-style: normal;
}
body {
  margin: 0;
  padding: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--bg-main);
  color: var(--color-gray-900);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* Evita zoom en inputs en iOS */
  -webkit-text-size-adjust: 100%;
}

* {
  box-sizing: border-box;
  font-family: "Inter", system-ui, -apple-system, sans-serif;
  margin: 0;
  padding: 0;
  /* Tap highlight transparente en mobile */
  -webkit-tap-highlight-color: transparent;
}

/* Scrollbar sutil */
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: var(--color-gray-400);
  border-radius: 2px;
}

.container {
  height: calc(100vh - var(--nav-height) - 72px);
  width: 100vw;
  overflow: auto;
  background-color: var(--bg-main);
  padding-top: 72px; /* altura del header */
  padding-bottom: var(--nav-height); /* altura del navbar inferior */
}

.container-louder {
  position: relative;
}

.subtittle-conten {
  position: relative;
}
.subtittle-conten i {
  display: flex;
  position: absolute;
  left: 0;
  height: 100%;
  top: 0;
  align-items: center;
  width: 25px;
  justify-content: center;
}

input:hover, input:focus, textarea:hover, textarea:focus, select:hover, select:focus {
  outline: none;
}

button, [role=button] {
  /* Mínimo 44px para toque accesible */
  min-height: 44px;
}
button:not(:disabled), [role=button]:not(:disabled) {
  cursor: pointer;
}

a {
  text-decoration: none;
  color: inherit;
}

.text-center {
  text-align: center !important;
}

.cursor-pointer {
  cursor: pointer !important;
}

.position-relative {
  position: relative;
}

.d-none {
  display: none !important;
}

.w-100 {
  width: 100% !important;
}

.h-100 {
  height: 100% !important;
}

/* Fuente para el nombre del usuario */
.font-user-name {
  font-size: 32px;
  font-weight: 600;
  line-height: 38.73px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  padding: 0;
  margin: 0;
}

/* Fuente principal por defecto de la página */
.font-main {
  font-size: 15px;
  font-weight: 400;
  line-height: 18.15px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: var(--color-gray-font);
}

/* Fuente para subtítulos y detalles */
.font-subtitle {
  padding: 10px;
  margin: 0;
  background: var(--color-blue-primary);
  color: var(--color-gray-100);
  border-radius: 5px 5px 0px 0px;
  font-size: 16px;
  font-weight: 600;
  line-height: 19.36px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}

/* Fuente principal en negrita */
.font-main-bold {
  font-size: 15px;
  font-weight: 700;
  line-height: 18.15px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}

/* Fuente pequeña normal */
.font-small {
  font-size: 14px;
  font-weight: 500;
  line-height: 19.01px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}

/* Fuente pequeña y delgada */
.font-small-thin {
  font-size: 14px;
  font-weight: 400;
  line-height: 16.94px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}

/* Fuente más pequeña */
.font-super-small {
  font-size: 13px;
  font-weight: 400;
  line-height: 15.73px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}

.font-W600 {
  font-weight: 600 !important;
}

.text-center {
  text-align: center !important;
}

/* Display */
.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

/* Direction */
.flex-row {
  flex-direction: row !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

/* Justify Content */
.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

/* Align Items */
.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

/* Align Content */
.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

/* Align Self */
.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

/* Flex Wrap */
.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

/* Flex Grow/Shrink */
/* Order */
.loader_page-active {
  opacity: 1;
  pointer-events: all;
  transition: all ease-in 0.1s;
}

.loader_page-hidden {
  opacity: 0;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/App.scss","webpack://./src/styles/vars/bordes-radius.scss","webpack://./src/styles/vars/colors.scss","webpack://./src/styles/vars/z-index.scss","webpack://./src/styles/utils/resets.scss","webpack://./src/styles/utils/general.scss","webpack://./src/styles/utils/fonts.scss","webpack://./src/styles/utils/flex.scss","webpack://./src/styles/componets/pageLayout.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACI,wBAAA;EACA,uBAAA;EACA,uBAAA;ADEJ;;AELA;EACI,wDAAA;EACA,wBAAA,EAAA,0BAAA;EACA,4BAAA,EAAA,gBAAA;EACA,8BAAA,EAAA,gBAAA;EACA,gCAAA,EAAA,oBAAA;EAEA,wDAAA;EACA,uBAAA,EAAA,mBAAA;EACA,6BAAA,EAAA,uBAAA;EACA,sBAAA,EAAA,iBAAA;EAEA,uDAAA;EACA,6BAAA;EACA,+BAAA;EACA,2BAAA;EACA,2BAAA;EACA,+BAAA;EACA,qBAAA;EACA,0BAAA;EAEA,wDAAA;EACA,sBAAA;EACA,4BAAA;EACA,oBAAA;EACA,0BAAA;EACA,uBAAA;EACA,uBAAA;EACA,qBAAA;EAEA,wDAAA;EACA,kBAAA,EAAA,4BAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;EAEA,wDAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EAEA,wDAAA;EACA,uBAAA;EACA,wCAAA;EACA,gCAAA;EACA,0CAAA;EACA,wCAAA;EAEA;iFAAA;EAEA,yDAAA;EAEA,wDAAA;EACA,uCAAA;EACA,uCAAA;EACA,wCAAA;EAEA,wDAAA;EACA,uBAAA;EAEA,wDAAA;EACA,oCAAA;EACA,6BAAA;EACA,qCAAA;EACA,oCAAA;AFFJ;;AEKA,4DAAA;AACA;EAAmB,4BAAA;AFDnB;;AEEA;EAAmB,4BAAA;AFEnB;;AEDA;EAAmB,WAAA;AFKnB;;AEJA;EAAmB,gCAAA;AFQnB;;AEPA;EAAqB,oCAAA;AFWrB;;AG1FA;EACI,oBAAA;EACA,kDAAA;EACA,mDAAA;EACA,qDAAA;EACA,uDAAA;EACA,uDAAA;EACA,uDAAA;EACA,6DAAA;EACA,mEAAA;EACA,yDAAA;AH6FJ;;AIvGA;EACI,oBAAA;EACA,+DAAA;EACA,oBAAA;EACA,kBAAA;AJ0GJ;AIvGA;EACI,SAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,gCAAA;EACA,4BAAA;EACA,mCAAA;EACA,kCAAA;EACA,gCAAA;EACA,8BAAA;AJyGJ;;AItGA;EACI,sBAAA;EACA,0DAAA;EACA,SAAA;EACA,UAAA;EACA,yCAAA;EACA,wCAAA;AJyGJ;;AItGA,oBAAA;AACA;EAAsB,UAAA;EAAY,WAAA;AJ2GlC;;AI1GA;EAA4B,uBAAA;AJ8G5B;;AI7GA;EAA4B,iCAAA;EAAmC,kBAAA;AJkH/D;;AIhHA;EACI,8CAAA;EACA,YAAA;EACA,cAAA;EACA,gCAAA;EACA,iBAAA,EAAA,sBAAA;EACA,iCAAA,EAAA,+BAAA;AJmHJ;;AIhHA;EACI,kBAAA;AJmHJ;;AIhHA;EACI,kBAAA;AJmHJ;AIjHI;EACI,aAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;EACA,MAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;AJmHR;;AI9GI;EAAmB,aAAA;AJkHvB;;AI/GA;EAEI,qCAAA;EACA,gBAAA;AJiHJ;AInHI;EAAmB,eAAA;AJsHvB;;AIjHA;EAAI,qBAAA;EAAuB,cAAA;AJsH3B;;AK9LA;EACI,6BAAA;ALiMJ;;AK9LA;EACI,0BAAA;ALiMJ;;AK9LA;EACI,kBAAA;ALiMJ;;AK9LA;EACI,wBAAA;ALiMJ;;AK9LA;EACI,sBAAA;ALiMJ;;AK9LA;EACI,uBAAA;ALiMJ;;AMtNA,sCAAA;AACA;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kCAAA;EACA,8BAAA;EACA,UAAA;EACA,SAAA;ANyNJ;;AMtNA,8CAAA;AACA;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kCAAA;EACA,8BAAA;EACA,6BAAA;ANyNJ;;AMtNA,sCAAA;AACA;EACI,aAAA;EACA,SAAA;EACA,qCAAA;EACA,4BAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kCAAA;EACA,8BAAA;ANyNJ;;AMtNA,gCAAA;AACA;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kCAAA;EACA,8BAAA;ANyNJ;;AMrNA,0BAAA;AACA;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kCAAA;EACA,8BAAA;ANwNJ;;AMrNA,6BAAA;AACA;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kCAAA;EACA,8BAAA;ANwNJ;;AMrNA,uBAAA;AACA;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kCAAA;EACA,8BAAA;ANwNJ;;AMrNA;EACI,2BAAA;ANwNJ;;AMrNA;EACI,6BAAA;ANwNJ;;AO5SA,YAAA;AACA;EACI,wBAAA;AP+SJ;;AO7SE;EACE,+BAAA;APgTJ;;AO7SE,cAAA;AACA;EACE,8BAAA;APgTJ;;AO9SE;EACE,sCAAA;APiTJ;;AO/SE;EACE,iCAAA;APkTJ;;AOhTE;EACE,yCAAA;APmTJ;;AOhTE,oBAAA;AACA;EACE,sCAAA;APmTJ;;AOjTE;EACE,oCAAA;APoTJ;;AOlTE;EACE,kCAAA;APqTJ;;AOnTE;EACE,yCAAA;APsTJ;;AOpTE;EACE,wCAAA;APuTJ;;AOrTE;EACE,wCAAA;APwTJ;;AOrTE,gBAAA;AACA;EACE,kCAAA;APwTJ;;AOtTE;EACE,gCAAA;APyTJ;;AOvTE;EACE,8BAAA;AP0TJ;;AOxTE;EACE,gCAAA;AP2TJ;;AOzTE;EACE,+BAAA;AP4TJ;;AOzTE,kBAAA;AACA;EACE,oCAAA;AP4TJ;;AO1TE;EACE,kCAAA;AP6TJ;;AO3TE;EACE,gCAAA;AP8TJ;;AO5TE;EACE,uCAAA;AP+TJ;;AO7TE;EACE,sCAAA;APgUJ;;AO9TE;EACE,iCAAA;APiUJ;;AO9TE,eAAA;AACA;EACE,2BAAA;APiUJ;;AO/TE;EACE,iCAAA;APkUJ;;AOhUE;EACE,+BAAA;APmUJ;;AOjUE;EACE,6BAAA;APoUJ;;AOlUE;EACE,+BAAA;APqUJ;;AOnUE;EACE,8BAAA;APsUJ;;AOnUE,cAAA;AACA;EACE,0BAAA;APsUJ;;AOpUE;EACE,4BAAA;APuUJ;;AOrUE;EACE,kCAAA;APwUJ;;AOrUE,qBAAA;AAcA,UAAA;AC5HF;EACI,UAAA;EACA,mBAAA;EACA,4BAAA;ARwbJ;;AQrbA;EACI,UAAA;EACA,oBAAA;ARwbJ","sourcesContent":["@charset \"UTF-8\";\n:root {\n  --border-radius-lg: 10px;\n  --border-radius-md: 5px;\n  --border-radius-sm: 4px;\n}\n\n:root {\n  /* ─── Primarios: campo / agro ─────────────────────── */\n  --color-primary: #1B4332; /* Verde bosque profundo */\n  --color-primary-mid: #2D6A4F; /* Verde medio */\n  --color-primary-light: #52B788; /* Verde claro */\n  --color-primary-surface: #D8F3DC; /* Verde muy suave */\n  /* ─── Acento: tierra / cosecha ────────────────────── */\n  --color-accent: #E76F00; /* Naranja tierra */\n  --color-accent-light: #FFF0D6; /* Fondo suave acento */\n  --color-amber: #F4A261; /* Ámbar cálido */\n  /* ─── Legado (compatibilidad shared) ─────────────── */\n  --color-blue-primary: #1B4332;\n  --color-blue-secondary: #2D6A4F;\n  --color-blue-light: #D8F3DC;\n  --color-blue-hover: #163527;\n  --color-dorado-primary: #F4A261;\n  --color-blue: #1B4332;\n  --color-lightblue: #52B788;\n  /* ─── Estado ──────────────────────────────────────── */\n  --color-green: #40916C;\n  --color-green-light: #D8F3DC;\n  --color-red: #D62828;\n  --color-red-light: #FFE5E5;\n  --color-yellow: #F4A261;\n  --color-orange: #E76F00;\n  --color-cyan: #2D6A4F;\n  /* ─── Superficies ─────────────────────────────────── */\n  --bg-main: #F2F4F0; /* Gris cálido, como papel */\n  --bg-white: #FFFFFF;\n  --bg-gray: #EAECE7;\n  --bg-gray-hover: #DDE0D9;\n  /* ─── Escala de grises ────────────────────────────── */\n  --color-gray-100: #FFFFFF;\n  --color-gray-200: #F5F6F4;\n  --color-gray-210: #F2F4F0;\n  --color-gray-300: #E2E6DF;\n  --color-gray-400: #C8CCC5;\n  --color-gray-500: #8E9489;\n  --color-gray-600: #5E6459;\n  --color-gray-800: #2C2F2A;\n  --color-gray-900: #1A1C19;\n  --color-gray-font: #5E6459;\n  /* ─── Header / NavBar oscuro ──────────────────────── */\n  --color-nav-bg: #1B4332;\n  --color-nav-text: rgba(255,255,255,0.75);\n  --color-nav-text-active: #FFFFFF;\n  --color-nav-active: rgba(255,255,255,0.15);\n  --color-nav-icon: rgba(255,255,255,0.65);\n  /* Altura del navbar inferior (responsiva) + safe-area del home indicator.\n     Usada por el navbar, el clearance global (.container) y el panel del mapa. */\n  --nav-height: calc(10vh + env(safe-area-inset-bottom, 0));\n  /* ─── Sombras ─────────────────────────────────────── */\n  --shadow-sm: 0 1px 3px rgba(0,0,0,0.08);\n  --shadow-md: 0 4px 12px rgba(0,0,0,0.1);\n  --shadow-lg: 0 8px 24px rgba(0,0,0,0.14);\n  /* ─── Bordes ──────────────────────────────────────── */\n  --border-color: #D5D9D2;\n  /* ─── Misc ────────────────────────────────────────── */\n  --color-trasparent: rgba(0,0,0,0.02);\n  --color-celeste-card: #D8F3DC;\n  --color-green-light-whatsapp: #128C7E;\n  --color-green-dark-whatsapp: #075E54;\n}\n\n/* ─── Utility classes ─────────────────────────────────── */\n.color-gray-900 {\n  color: var(--color-gray-900);\n}\n\n.color-gray-500 {\n  color: var(--color-gray-500);\n}\n\n.text-white {\n  color: #fff;\n}\n\n.bg-blue-primary {\n  background: var(--color-primary);\n}\n\n.bg-blue-secondary {\n  background: var(--color-primary-mid);\n}\n\n:root {\n  --z-index-base: 1000;\n  --z-index-overlay: calc(var(--z-index-base) + 100);\n  --z-index-modal: calc(var(--z-index-overlay) + 100);\n  --z-index-overlay-2: calc(var(--z-index-modal) + 100);\n  --z-index-modal-2: calc(var(--z-index-overlay-2) + 100);\n  --z-index-overlay-3: calc(var(--z-index-modal-2) + 100);\n  --z-index-modal-3: calc(var(--z-index-overlay-3) + 100);\n  --z-index-overlay-confirm: calc(var(--z-index-modal-3) + 100);\n  --z-index-modal-confirm: calc(var(--z-index-overlay-confirm) + 100);\n  --z-index-alert: calc(var(--z-index-modal-confirm) + 100);\n}\n\n@font-face {\n  font-family: \"Inter\";\n  src: url(\"../../assets/fonts/Inter-VariableFont_opsz,wght.ttf\") format(\"truetype\");\n  font-weight: 100 900;\n  font-style: normal;\n}\nbody {\n  margin: 0;\n  padding: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--bg-main);\n  color: var(--color-gray-900);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  /* Evita zoom en inputs en iOS */\n  -webkit-text-size-adjust: 100%;\n}\n\n* {\n  box-sizing: border-box;\n  font-family: \"Inter\", system-ui, -apple-system, sans-serif;\n  margin: 0;\n  padding: 0;\n  /* Tap highlight transparente en mobile */\n  -webkit-tap-highlight-color: transparent;\n}\n\n/* Scrollbar sutil */\n::-webkit-scrollbar {\n  width: 4px;\n  height: 4px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--color-gray-400);\n  border-radius: 2px;\n}\n\n.container {\n  height: calc(100vh - var(--nav-height) - 72px);\n  width: 100vw;\n  overflow: auto;\n  background-color: var(--bg-main);\n  padding-top: 72px; /* altura del header */\n  padding-bottom: var(--nav-height); /* altura del navbar inferior */\n}\n\n.container-louder {\n  position: relative;\n}\n\n.subtittle-conten {\n  position: relative;\n}\n.subtittle-conten i {\n  display: flex;\n  position: absolute;\n  left: 0;\n  height: 100%;\n  top: 0;\n  align-items: center;\n  width: 25px;\n  justify-content: center;\n}\n\ninput:hover, input:focus, textarea:hover, textarea:focus, select:hover, select:focus {\n  outline: none;\n}\n\nbutton, [role=button] {\n  /* Mínimo 44px para toque accesible */\n  min-height: 44px;\n}\nbutton:not(:disabled), [role=button]:not(:disabled) {\n  cursor: pointer;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.cursor-pointer {\n  cursor: pointer !important;\n}\n\n.position-relative {\n  position: relative;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n/* Fuente para el nombre del usuario */\n.font-user-name {\n  font-size: 32px;\n  font-weight: 600;\n  line-height: 38.73px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  padding: 0;\n  margin: 0;\n}\n\n/* Fuente principal por defecto de la página */\n.font-main {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 18.15px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  color: var(--color-gray-font);\n}\n\n/* Fuente para subtítulos y detalles */\n.font-subtitle {\n  padding: 10px;\n  margin: 0;\n  background: var(--color-blue-primary);\n  color: var(--color-gray-100);\n  border-radius: 5px 5px 0px 0px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 19.36px;\n  text-align: center;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n\n/* Fuente principal en negrita */\n.font-main-bold {\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 18.15px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n\n/* Fuente pequeña normal */\n.font-small {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 19.01px;\n  text-align: center;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n\n/* Fuente pequeña y delgada */\n.font-small-thin {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 16.94px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n\n/* Fuente más pequeña */\n.font-super-small {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 15.73px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n\n.font-W600 {\n  font-weight: 600 !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n/* Display */\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n/* Direction */\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n/* Justify Content */\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.justify-content-evenly {\n  justify-content: space-evenly !important;\n}\n\n/* Align Items */\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n/* Align Content */\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n/* Align Self */\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n/* Flex Wrap */\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n/* Flex Grow/Shrink */\n/* Order */\n.loader_page-active {\n  opacity: 1;\n  pointer-events: all;\n  transition: all ease-in 0.1s;\n}\n\n.loader_page-hidden {\n  opacity: 0;\n  pointer-events: none;\n}",":root {\n    --border-radius-lg: 10px; \n    --border-radius-md: 5px;\n    --border-radius-sm: 4px;\n}\n",":root {\n    /* ─── Primarios: campo / agro ─────────────────────── */\n    --color-primary:          #1B4332;    /* Verde bosque profundo */\n    --color-primary-mid:      #2D6A4F;    /* Verde medio */\n    --color-primary-light:    #52B788;    /* Verde claro */\n    --color-primary-surface:  #D8F3DC;    /* Verde muy suave */\n\n    /* ─── Acento: tierra / cosecha ────────────────────── */\n    --color-accent:           #E76F00;    /* Naranja tierra */\n    --color-accent-light:     #FFF0D6;    /* Fondo suave acento */\n    --color-amber:            #F4A261;    /* Ámbar cálido */\n\n    /* ─── Legado (compatibilidad shared) ─────────────── */\n    --color-blue-primary:     #1B4332;\n    --color-blue-secondary:   #2D6A4F;\n    --color-blue-light:       #D8F3DC;\n    --color-blue-hover:       #163527;\n    --color-dorado-primary:   #F4A261;\n    --color-blue:             #1B4332;\n    --color-lightblue:        #52B788;\n\n    /* ─── Estado ──────────────────────────────────────── */\n    --color-green:            #40916C;\n    --color-green-light:      #D8F3DC;\n    --color-red:              #D62828;\n    --color-red-light:        #FFE5E5;\n    --color-yellow:           #F4A261;\n    --color-orange:           #E76F00;\n    --color-cyan:             #2D6A4F;\n\n    /* ─── Superficies ─────────────────────────────────── */\n    --bg-main:                #F2F4F0;    /* Gris cálido, como papel */\n    --bg-white:               #FFFFFF;\n    --bg-gray:                #EAECE7;\n    --bg-gray-hover:          #DDE0D9;\n\n    /* ─── Escala de grises ────────────────────────────── */\n    --color-gray-100:         #FFFFFF;\n    --color-gray-200:         #F5F6F4;\n    --color-gray-210:         #F2F4F0;\n    --color-gray-300:         #E2E6DF;\n    --color-gray-400:         #C8CCC5;\n    --color-gray-500:         #8E9489;\n    --color-gray-600:         #5E6459;\n    --color-gray-800:         #2C2F2A;\n    --color-gray-900:         #1A1C19;\n    --color-gray-font:        #5E6459;\n\n    /* ─── Header / NavBar oscuro ──────────────────────── */\n    --color-nav-bg:           #1B4332;\n    --color-nav-text:         rgba(255,255,255,0.75);\n    --color-nav-text-active:  #FFFFFF;\n    --color-nav-active:       rgba(255,255,255,0.15);\n    --color-nav-icon:         rgba(255,255,255,0.65);\n\n    /* Altura del navbar inferior (responsiva) + safe-area del home indicator.\n       Usada por el navbar, el clearance global (.container) y el panel del mapa. */\n    --nav-height: calc(10vh + env(safe-area-inset-bottom, 0));\n\n    /* ─── Sombras ─────────────────────────────────────── */\n    --shadow-sm:  0 1px 3px rgba(0,0,0,0.08);\n    --shadow-md:  0 4px 12px rgba(0,0,0,0.1);\n    --shadow-lg:  0 8px 24px rgba(0,0,0,0.14);\n\n    /* ─── Bordes ──────────────────────────────────────── */\n    --border-color: #D5D9D2;\n\n    /* ─── Misc ────────────────────────────────────────── */\n    --color-trasparent:       rgba(0,0,0,0.02);\n    --color-celeste-card:     #D8F3DC;\n    --color-green-light-whatsapp: #128C7E;\n    --color-green-dark-whatsapp:  #075E54;\n}\n\n/* ─── Utility classes ─────────────────────────────────── */\n.color-gray-900  { color: var(--color-gray-900); }\n.color-gray-500  { color: var(--color-gray-500); }\n.text-white      { color: #fff; }\n.bg-blue-primary { background: var(--color-primary); }\n.bg-blue-secondary { background: var(--color-primary-mid); }\n",":root {\n    --z-index-base: 1000;\n    --z-index-overlay: calc(var(--z-index-base) + 100);\n    --z-index-modal: calc(var(--z-index-overlay) + 100);\n    --z-index-overlay-2: calc(var(--z-index-modal) + 100);\n    --z-index-modal-2: calc(var(--z-index-overlay-2) + 100);\n    --z-index-overlay-3: calc(var(--z-index-modal-2) + 100);\n    --z-index-modal-3: calc(var(--z-index-overlay-3) + 100);\n    --z-index-overlay-confirm: calc(var(--z-index-modal-3) + 100);\n    --z-index-modal-confirm: calc(var(--z-index-overlay-confirm) + 100);\n    --z-index-alert: calc(var(--z-index-modal-confirm) + 100);\n}","@font-face {\n    font-family: 'Inter';\n    src: url('../../assets/fonts/Inter-VariableFont_opsz,wght.ttf') format('truetype');\n    font-weight: 100 900;\n    font-style: normal;\n}\n\nbody {\n    margin: 0;\n    padding: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: var(--bg-main);\n    color: var(--color-gray-900);\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    /* Evita zoom en inputs en iOS */\n    -webkit-text-size-adjust: 100%;\n}\n\n* {\n    box-sizing: border-box;\n    font-family: 'Inter', system-ui, -apple-system, sans-serif;\n    margin: 0;\n    padding: 0;\n    /* Tap highlight transparente en mobile */\n    -webkit-tap-highlight-color: transparent;\n}\n\n/* Scrollbar sutil */\n::-webkit-scrollbar { width: 4px; height: 4px; }\n::-webkit-scrollbar-track { background: transparent; }\n::-webkit-scrollbar-thumb { background: var(--color-gray-400); border-radius: 2px; }\n\n.container {\n    height: calc(100vh - var(--nav-height) - 72px);\n    width: 100vw;\n    overflow: auto;\n    background-color: var(--bg-main);\n    padding-top: 72px; /* altura del header */\n    padding-bottom: var(--nav-height); /* altura del navbar inferior */\n}\n\n.container-louder {\n    position: relative;\n}\n\n.subtittle-conten {\n    position: relative;\n\n    i {\n        display: flex;\n        position: absolute;\n        left: 0;\n        height: 100%;\n        top: 0;\n        align-items: center;\n        width: 25px;\n        justify-content: center;\n    }\n}\n\ninput, textarea, select {\n    &:hover, &:focus { outline: none; }\n}\n\nbutton, [role='button'] {\n    &:not(:disabled) { cursor: pointer; }\n    /* Mínimo 44px para toque accesible */\n    min-height: 44px;\n}\n\na { text-decoration: none; color: inherit; }\n",".text-center {\n    text-align: center !important;\n}\n\n.cursor-pointer {\n    cursor: pointer !important;\n}\n\n.position-relative{\n    position: relative;\n}\n\n.d-none {\n    display: none !important;\n}\n\n.w-100 {\n    width: 100% !important;\n}\n\n.h-100 {\n    height: 100% !important;\n}","/* Fuente para el nombre del usuario */\n.font-user-name {\n    font-size: 32px;\n    font-weight: 600;\n    line-height: 38.73px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    padding: 0;\n    margin: 0;\n}\n\n/* Fuente principal por defecto de la página */\n.font-main {\n    font-size: 15px;\n    font-weight: 400;\n    line-height: 18.15px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: var(--color-gray-font);\n}\n\n/* Fuente para subtítulos y detalles */\n.font-subtitle {\n    padding: 10px;\n    margin: 0;\n    background: var(--color-blue-primary);\n    color: var(--color-gray-100);\n    border-radius: 5px 5px 0px 0px;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 19.36px;\n    text-align: center;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n}\n\n/* Fuente principal en negrita */\n.font-main-bold {\n    font-size: 15px;\n    font-weight: 700;\n    line-height: 18.15px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n\n}\n\n/* Fuente pequeña normal */\n.font-small {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 19.01px;\n    text-align: center;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n}\n\n/* Fuente pequeña y delgada */\n.font-small-thin {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 16.94px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n}\n\n/* Fuente más pequeña */\n.font-super-small {\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 15.73px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n}\n\n.font-W600 {\n    font-weight: 600 !important;\n}\n\n.text-center {\n    text-align: center !important;\n}","/* Display */\n.d-flex {\n    display: flex !important;\n  }\n  .d-inline-flex {\n    display: inline-flex !important;\n  }\n  \n  /* Direction */\n  .flex-row {\n    flex-direction: row !important;\n  }\n  .flex-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-column {\n    flex-direction: column !important;\n  }\n  .flex-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  \n  /* Justify Content */\n  .justify-content-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-center {\n    justify-content: center !important;\n  }\n  .justify-content-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-evenly {\n    justify-content: space-evenly !important;\n  }\n  \n  /* Align Items */\n  .align-items-start {\n    align-items: flex-start !important;\n  }\n  .align-items-end {\n    align-items: flex-end !important;\n  }\n  .align-items-center {\n    align-items: center !important;\n  }\n  .align-items-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-stretch {\n    align-items: stretch !important;\n  }\n  \n  /* Align Content */\n  .align-content-start {\n    align-content: flex-start !important;\n  }\n  .align-content-end {\n    align-content: flex-end !important;\n  }\n  .align-content-center {\n    align-content: center !important;\n  }\n  .align-content-between {\n    align-content: space-between !important;\n  }\n  .align-content-around {\n    align-content: space-around !important;\n  }\n  .align-content-stretch {\n    align-content: stretch !important;\n  }\n  \n  /* Align Self */\n  .align-self-auto {\n    align-self: auto !important;\n  }\n  .align-self-start {\n    align-self: flex-start !important;\n  }\n  .align-self-end {\n    align-self: flex-end !important;\n  }\n  .align-self-center {\n    align-self: center !important;\n  }\n  .align-self-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-stretch {\n    align-self: stretch !important;\n  }\n  \n  /* Flex Wrap */\n  .flex-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  \n  /* Flex Grow/Shrink */\n//   .flex-grow-0 {\n//     flex-grow: 0 !important;\n//   }\n//   .flex-grow-1 {\n//     flex-grow: 1 !important;\n//   }\n//   .flex-shrink-0 {\n//     flex-shrink: 0 !important;\n//   }\n//   .flex-shrink-1 {\n//     flex-shrink: 1 !important;\n//   }\n  \n  /* Order */\n//   .order-0 {\n//     order: 0 !important;\n//   }\n//   .order-1 {\n//     order: 1 !important;\n//   }\n//   .order-2 {\n//     order: 2 !important;\n//   }\n//   .order-3 {\n//     order: 3 !important;\n//   }\n//   .order-4 {\n//     order: 4 !important;\n//   }\n//   .order-5 {\n//     order: 5 !important;\n//   }\n//   .order-first {\n//     order: -1 !important;\n//   }\n//   .order-last {\n//     order: 6 !important;\n//   }\n  ",".loader_page-active {\n    opacity: 1;\n    pointer-events: all;\n    transition: all ease-in .1s;\n}\n\n.loader_page-hidden {\n    opacity: 0;\n    pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
